import { ListItemIcon, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { useTimeoutTimer } from "@src/appV2/lib/utils/useTimeoutTimer";
import { useMemo } from "react";

import { formatCountdownTime } from "../utils";

interface AuctionCountdownTimerProps {
  secondsLeft: number;
}

export function AuctionCountdownTimer(props: AuctionCountdownTimerProps) {
  const { secondsLeft } = props;

  const countdownDisplay = useMemo(() => formatCountdownTime(secondsLeft), [secondsLeft]);

  return (
    <Stack direction="row" alignItems="center">
      <ListItemIcon
        iconType="clock"
        color={(theme) => theme.palette.text.secondary}
        sx={{ minWidth: "unset", mr: 1 }}
      />
      {secondsLeft <= 0 ? (
        <Text variant="h6" color={(theme) => theme.palette.arrivalTime?.accent}>
          Auction has ended
        </Text>
      ) : (
        <>
          <Text bold variant="h6" color={(theme) => theme.palette.arrivalTime?.accent}>
            {countdownDisplay}
          </Text>
          <Text variant="h6" color={(theme) => theme.palette.text.secondary} sx={{ ml: 1 }}>
            left
          </Text>
        </>
      )}
    </Stack>
  );
}

export function useAuctionTimer(endTime: Date) {
  const { secondsLeft } = useTimeoutTimer({
    initialEndTime: endTime.getTime(),
  });

  return { isExpired: secondsLeft <= 0, secondsLeft };
}
